import { hotjar } from 'react-hotjar';
import { HOTJAR_VERSION } from 'src/constants';
import env from '../env';

export const initializeHotJar = (): void => {
  hotjar.initialize({
    id: parseInt(env.HOTJAR_SITE_ID),
    sv: HOTJAR_VERSION,
  });
};
